export enum CATEGORY {
  NONE = '',
  DOCTOR = 'doctor',
  FACILITY = 'facility',
}

export const FACILITIES_DROPDOWN_OPTIONS = [
  { value: 'A0', label: 'Hospitals' },
  { value: '49', label: 'Ambulatory Surgical Centers' },
  { value: '30', label: 'Imaging Centers' },
  { value: '69', label: 'Lab Centers' },
  { value: '65', label: 'Physical Therapy' },
  { value: '93', label: 'Urgent Care' },
]

export const PCP_SERVICE_LINE = 'Primary Care'
export const PCP_PEDIATRIC_SERVICE_LINE = 'Pediatric Primary Care'

export const PCP_SERVICE_LINE_NAMES = [
  PCP_SERVICE_LINE,
  PCP_PEDIATRIC_SERVICE_LINE,
]
